import { createContext } from 'react';
import { isDesktop, isMobile } from 'react-device-detect';

import { SectionDisplayName } from '../config/index';

export interface SectionConfig {
  hide?: boolean;
  showMarketing?: boolean;
}

export interface ComfortConfig extends SectionConfig {
  hasZones?: boolean;
}

export interface AppConfig {
  isMobile: boolean;
  isDesktop: boolean;
  meta?: {
    campusName?: string;
    currentSectionName?: SectionDisplayName;
    currentPageName?: string;
  };
  sections: {
    comfort: ComfortConfig;
    ev: SectionConfig;
    battery: SectionConfig;
  };
}

export interface AppContextValue {
  appConfig: AppConfig;
  setAppConfig: React.Dispatch<React.SetStateAction<AppConfig>>;
}

export const defaultAppConfig: AppConfig = {
  isMobile: isMobile || false,
  isDesktop: isDesktop || false,
  sections: {
    comfort: {
      hasZones: true,
      showMarketing: false,
    },
    ev: {
      hide: false,
      showMarketing: false,
    },
    battery: {
      hide: false,
      showMarketing: false,
    },
  },
};

export const AppContext = createContext<AppContextValue>({
  appConfig: defaultAppConfig,
  setAppConfig: () => {},
});
